import React from 'react';
import './Footer.css'; // Import the CSS file

const Footer = () => {
  return (
    <div className="comark-signature">
      <a href="https://yourwebsiteurl.com" target="_blank" rel="noopener noreferrer">
        <img
          src="https://comarkit.com/delivery/icon_43x20.png"
          alt="לוגו COMARK"
          className="comark-logo"
        />
      </a>
      <a
        href="https://yourwebsiteurl.com"
        target="_blank"
        rel="noopener noreferrer"
        className="comark-text"
      >
        Comark, <span>Web and Apps</span>
      </a>
     
    </div>
  );
};

export default Footer;
